// extracted by mini-css-extract-plugin
export default {"imageContainer":"N1-z","summaryPar":"O1-z","ratingCategories":"P1-z","reviewerInfo":"Q1-z","reviewTypes":"R1-z","expanded":"S1-z"};